import { call } from './utils';

export const publishMess = async (data, accessToken) =>
  await call({
    url: '/api/station/publish',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const subscribeMess = async (data, accessToken) =>
  await call({
    url: '/api/station/subscribe',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const createStation = async (data, accessToken) =>
  await call({
    url: '/api/station/create',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const updateStation = async (data, accessToken) =>
  await call({
    url: '/api/station/update',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const removeStation = async (data, accessToken) =>
  await call({
    url: '/api/station/remove',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findAllStations = async (data, accessToken) =>
  await call({
    url: '/api/station/find/all',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findStationById = async (data, accessToken) =>
  await call({
    url: '/api/station/find/by/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findStationByName = async (data, accessToken) =>
  await call({
    url: '/api/station/by/name',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findStationByUserId = async (data, accessToken) =>
  await call({
    url: '/api/station/by/user/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });

export const fetchFreeSpotsInTheStation = async (data, accessToken) =>
  await call({
    url: '/api/station/find/free/spots',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const fetchFreeSpotsForciblyClosed = async (data, accessToken) =>
  await call({
    url: '/api/station/find/free/spots/forcibly',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
